import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { BaseHTTPError } from '@fe-core/errors';
import {
  getSessions,
  TSessionsResponse,
} from '@fe-learner-common/api/queries/session';
import { useConfigContext } from '@fe-core';

const QUERY_KEY = 'sessions';

export const useSessions = ({ enabled }: { enabled: boolean }) => {
  const { config } = useConfigContext();
  if (!config.apiUrls.ccapi) {
    throw new Error('Missing API URL');
  }

  return useQuery<TSessionsResponse, BaseHTTPError>({
    queryKey: [QUERY_KEY],
    queryFn: async () =>
      getSessions({ baseUrl: config.apiUrls.ccapi as string }),
    placeholderData: keepPreviousData,
    retry: false,
    staleTime: Infinity,
    enabled: enabled,
  });
};
